module.exports = "https://static.wmbcdn.com/uniweb/images/0f8e5e728b9559152d7bbbe015eeef2a.svg";